import React, { useState } from "react";
import { FileOutput } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import CommercialInvoice from "./forms/CommercialInvoice";
import NonIncidentForm from "./forms/NonIncidentForm";
import ManitoulinBOL from "./forms/ManitoulinBOL";

const FORMS = [
  { key: "invoice", label: "Commercial Invoice" },
  { key: "non_incident", label: "Non-Incident Form" },
  { key: "manitoulin_bol", label: "Manitoulin BOL" },
];

export default function FormGenerator() {
  const [form, setForm] = useState("invoice");
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="form-generator-page">
      <div className="font-mono text-[10px] uppercase tracking-widest text-gray-500 flex items-center gap-1.5">
        <FileOutput className="w-3 h-3" /> Stores · Form Generator
      </div>
      <h1 className="font-display text-4xl md:text-5xl font-semibold tracking-tight mt-1">Form Generator</h1>
      <p className="text-sm text-gray-500 mt-2">Fill out a form and export a print-ready PDF. Nothing is saved — the PDF downloads straight to your device.</p>
      <div className="mt-5 max-w-xs">
        <label className="font-mono text-[10px] uppercase tracking-widest text-gray-500">Form</label>
        <Select value={form} onValueChange={setForm}>
          <SelectTrigger className="mt-1 h-10 bg-white" data-testid="fg-form-select">
            <SelectValue placeholder="Select a form" />
          </SelectTrigger>
          <SelectContent>
            {FORMS.map((f) => (
              <SelectItem key={f.key} value={f.key} data-testid={`fg-form-option-${f.key}`}>
                {f.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="mt-6">
        {form === "invoice" ? <CommercialInvoice /> : form === "non_incident" ? <NonIncidentForm /> : <ManitoulinBOL />}
      </div>
    </div>
  );
}
